import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function formReducer(state = initialstate.form, action) {
	switch (action.type) {
		case types.POST_FORM:
			return action.response || state;
		default:
			return state;
	}
}
